import { defineComponent } from 'vue';
import CategoryFourComponent from '@/components/CategoryFour/CategoryFourComponent.vue';
export default defineComponent({
    name: 'CategoryFour',
    components: { CategoryFourComponent },
    data() {
        return {};
    }
});
